import React, { useEffect, useState } from 'react';
import MUIDataTable from 'mui-datatables';
import Button from '@mui/material/Button';
import customHead from 'constants/customHead';
import { getTempUserList } from '../../../../actions/admin';
import { connect } from 'react-redux';
import CircularProgress from '@mui/material/CircularProgress';
import moment from 'moment';
import Tooltip from '@mui/material/Tooltip';
import AdminContainer from 'containers/AdminContainer';
import { ThemeProvider, createTheme } from '@mui/material';
import Pagination from '@mui/material/Pagination';
import PaginationCount from 'app/routes/components/PaginationCount';
import Chip from '@mui/material/Chip';

const theme = createTheme({
  components: {
    MUIDataTableFilter: {
      styleOverrides: {
        reset: {
          display: "none"
        }
      }
    }
  }
});

function GuestUserList(props) {
  const [state, setState] = useState({
    pageNo: 0,
    size: 50,
    searchedText: '',
  });

  const fetchData = (pageNo = 1, searchText = '') => {
    let data = {
      pageNo,
      size: state.size,
      searchText
    };
    props.getTempUserList({ data });
  };

  useEffect(() => {
    fetchData(1, '');
  }, []);

  const changePage = (pageNo) => {
    fetchData(pageNo + 1, state.searchedText);
    setState(prev => ({ ...prev, pageNo }));
  };

  const handleSearch = (searchText) => {
    fetchData(1, searchText);
    setState(prev => ({ ...prev, searchedText: searchText, pageNo: 0 }));
  };

  const { tempUserList } = props;

  const totalRecords = tempUserList && tempUserList.detail && tempUserList.detail[0]
    && tempUserList.detail[0].metadata && tempUserList.detail[0].metadata.length > 0
    ? tempUserList.detail[0].metadata[0].total : 0;

  const options = {
    searchPlaceholder: 'Press Enter to Search',
    filterType: 'dropdown',
    print: false,
    download: false,
    selectableRows: false,
    selectableRowsOnClick: false,
    selectableRowsHeader: false,
    responsive: 'scroll',
    search: true,
    rowsPerPage: 50,
    page: state.pageNo,
    count: totalRecords,
    rowsPerPageOptions: [],
    viewColumns: false,
    rowHover: false,
    filter: false,
    serverSide: true,
    searchText: state.searchedText,
    onTableChange: (action, tableState) => {
      switch (action) {
        case 'changePage':
          changePage(tableState.page);
          break;
        case 'search':
          onkeypress = (e) => {
            if (e.key === 'Enter') {
              handleSearch(tableState.searchText);
            }
          };
          break;
        case 'onSearchClose':
          handleSearch('');
          break;
        default:
          break;
      }
    },
    customFooter: (count, page, rowsPerPage, changeRowsPerPage, changePage) => {
      return (
        <div className="p-4 d-flex justify-content-end">
          <PaginationCount page={page} rowsPerPage={rowsPerPage} count={count} />
          <Pagination
            count={Math.ceil(count / rowsPerPage)}
            page={page + 1}
            onChange={(e, page) => { changePage(page - 1) }}
            color="primary"
          />
        </div>
      );
    }
  };

  const columns = [
    {
      name: "name",
      label: "Name",
      options: {
        filter: false,
        sort: false,
        customHeadRender: (o, updateDirection) => customHead(o, updateDirection)
      }
    },
    {
      name: "phone",
      label: "Phone",
      options: {
        filter: false,
        sort: false,
        customHeadRender: (o, updateDirection) => customHead(o, updateDirection)
      }
    },
    {
      name: "email",
      label: "Email",
      options: {
        filter: false,
        sort: false,
        customHeadRender: (o, updateDirection) => customHead(o, updateDirection)
      }
    },
    {
      name: "company",
      label: "Company",
      options: {
        filter: false,
        sort: false,
        customHeadRender: (o, updateDirection) => customHead(o, updateDirection)
      }
    },
    {
      name: "city",
      label: "City",
      options: {
        filter: false,
        sort: false,
        customHeadRender: (o, updateDirection) => customHead(o, updateDirection)
      }
    },
    // {
    //   name: "source",
    //   label: "Source",
    //   options: {
    //     filter: false,
    //     sort: false,
    //     customHeadRender: (o, updateDirection) => customHead(o, updateDirection)
    //   }
    // },
    {
      name: "sessions",
      label: "Sessions",
      options: {
        filter: false,
        sort: false,
        customHeadRender: (o, updateDirection) => customHead(o, updateDirection)
      }
    },
    {
      name: "lastSession",
      label: "Latest Session",
      options: {
        filter: false,
        sort: false,
        customHeadRender: (o, updateDirection) => customHead(o, updateDirection)
      }
    },
    {
      name: "status",
      label: "Status",
      options: {
        filter: false,
        sort: false,
        customHeadRender: (o, updateDirection) => customHead(o, updateDirection)
      }
    }
  ];

  let data = [];
  if (tempUserList && tempUserList.detail && tempUserList.detail[0] && tempUserList.detail[0].data) {
    tempUserList.detail[0].data.forEach((user) => {
      const lastSession = user.last_session;
      const isActive = user.active_sessions > 0;

      data.push({
        name: user.name || '-',
        phone: user.phone || '-',
        email: user.email || '-',
        company: user.company_name || '-',
        city: user.city || '-',
        source: user.source || 'website',
        sessions: (
          <Tooltip title={`Active: ${user.active_sessions || 0}`} placement="top">
            <span>{user.total_sessions || 0}</span>
          </Tooltip>
        ),
        lastSession: lastSession && lastSession.login_at
          ? moment(lastSession.login_at).format('DD MMM YYYY, hh:mm A')
          : (user.last_visited ? moment(user.last_visited).format('DD MMM YYYY, hh:mm A') : '-'),
        status: isActive
          ?  <div key={'recent'} className={` badge text-uppercase text-white bg-green`}>Active</div>
          : <div key={'recent'} className={` badge text-uppercase text-white bg-red`}>Inactive</div>
      });
    });
  }

  return (
    <React.Fragment>
      <AdminContainer>
        <div className="page-heading d-sm-flex justify-content-sm-between align-items-sm-center">
          <h2 className="title mb-3 mb-sm-0">Guest Users</h2>
        </div>
        {props.loading ? (
          <div className="loader-view" style={{ height: 'calc(100vh - 259px)' }}>
            <CircularProgress />
          </div>
        ) : null}

        {!props.loading && (
          <ThemeProvider theme={theme}>
            <MUIDataTable
              data={data}
              columns={columns}
              options={options}
            />
          </ThemeProvider>
        )}
      </AdminContainer>
    </React.Fragment>
  );
}

const mapStateToProps = ({ admin }) => {
  const { tempUserList, loading } = admin;
  return { tempUserList, loading };
};

export default connect(mapStateToProps, { getTempUserList })(GuestUserList);
